<template>
  <div>
    <a-modal
      v-show="!ishand"
      id="warp_sim12"
      width="40rem"
      v-model="visible"
      on-ok="handleOk1"
      v-dragModal
      @cancel="handleCancel(0)"
      :footer="null"
      :keyboard="false"
      :maskClosable="false"
      :dialog-style="{top: 22 +'%'}"
    >
      <div class="mark-file">
        <div
          style="
            background-color: #0c8b97;
            border-radius: 10px 10px 0 0;
            color: #fff;
            width: 38rem;
            margin: 1rem 1rem 0 1rem;
            text-align: center;
          "
        >
          個人信息
        </div>
      </div>
      <div solt="title" style="position: relative">
        <!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
      </div>
      <div class="content">
        <div style="padding-top: 1rem;">
            <div style="border: 1px solid #e5e5e5;">
                <div class="content-top1" style="background:#fafafa;">
                    <span style="flex: 1;">證券帳號 <span style="margin-left: 10%;">{{dataAll.username}}</span></span>
                    <span style="flex: 1;margin-left: 50px;">中文名稱 <span style="margin-left: 10%;">{{dataAll.cn_name}}</span></span>
                </div>
                <div class="content-top1">
                    <span style="flex: 1;display: flex;">英文名稱<span :title="dataAll.en_name" style="margin-left: 10%;display: inline-block;width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{dataAll.en_name}}</span></span>
                    <span style="flex: 1;margin-left: 50px;" :style="dataAll.phonenum_edit == 1 ?'color:#0c8b97':''">電話號碼 <span style="margin-left: 10%;"><span v-if="dataAll.nationcode">{{dataAll.nationcode}}</span>{{dataAll.phonenum}}</span></span>
                </div>
                <div class="content-top1" style="background:#fafafa;">
                    <span style="flex: 1;" :style="dataAll.email_edit == 1 ?'color:#0c8b97':''">電郵地址 <span style="display: inline-block;width: 70%;height: 100%;overflow: hidden;float: right;position: relative;right: 1%;text-overflow: ellipsis;white-space: nowrap;" :title="dataAll.email">{{dataAll.email}}</span></span>
                    <span style="flex: 1;margin-left: 50px;">銀行名稱 <span style="margin-left: 10%;">{{dataAll.bank}}</span></span>
                </div>
                <div class="content-top1">
                    <span style="flex: 1;">銀行號碼<span style="margin-left: 10%;" >{{dataAll.bank_number}}</span></span>
                    <span style="flex: 1;margin-left: 50px;">登錄平台 
                        <span style="margin-left: 10%;" class="denglu" v-if="dataAll.way">{{dataAll.way}}</span>
                        <span style="margin-left: 10%;" class="denglu" v-else>
                            <a-select
                            v-model="filetype"
                            placeholder="請選擇登錄平台"
                            >
                              <a-select-option
                                  v-for="item in fileArr1"
                                  :key="item.value"
                                  :label="item.value"
                                  :value="item.value"
                              >
                                {{ item.label }}
                              </a-select-option
                            >
                            </a-select>
                        </span>
                    </span>
                </div>
                <div class="content-top1" style="background:#fafafa;">
                    <span style="flex: 1;display:flex;align-items:center;" :style="dataAll.address_edit == 1 ?'color:#0c8b97':''">
                      <span style="flex-shrink: 0;">通讯地址</span> 
                      <span style="margin-left: 4.5%;white-space: nowrap; overflow: hidden;text-overflow: ellipsis;" :title="dataAll.address">{{dataAll.address}}</span>
                      <img :src="require('../../../../image/dzck.png')" style="margin-left: 3%;margin-bottom: 1px;cursor: pointer;" @click="setVisible = true" v-if="dataAll.addresspicurl">
                      <handItem v-if='setVisible' @child='handfn' :record='dataAll.addresspicurl'></handItem>
                    </span>
                </div>
                <div class="content-top1" v-if="dataAll.is_like == 0">
                    <span style="flex: 1;display:flex;align-items:center;" :style="dataAll.address_edit == 1 ?'color:#0c8b97':''">
                      <span style="flex-shrink: 0;">住宅地址</span> 
                      <span style="margin-left: 4.5%;white-space: nowrap; overflow: hidden;text-overflow: ellipsis;" :title="dataAll.new_residential_address">{{dataAll.new_residential_address}}</span>
                      <img :src="require('../../../../image/dzck.png')" style="margin-left: 3%;margin-bottom: 1px;cursor: pointer;" @click="setVisible1 = true" v-if="dataAll.residential_address_pic">
                      <handItem v-if='setVisible1' @child='handfn' :record='dataAll.residential_address_pic'></handItem>
                    </span>
                </div>
            </div>
        </div>
        <div style="margin-top: 15px;" v-if="userfileAuditAdmin">
            <a-textarea v-model="value2"  placeholder="請輸入備註信息" allow-clear />
        </div>
        <div style="text-align: center;margin-top: 15px;"  v-if="userfileAuditAdmin">
            <button class="btnOn" @click="btnOkClick(2)">審核拒絕</button>
            <button class="btnOK" @click="btnOkClick(1)">審批通過</button>
        </div>
      </div>

      <div style="width: 100%; height: 1px"></div>
    </a-modal>
  </div>
</template>

<script>
import handItem from './handItem1'
import App from "@/assets/app.js";
export default {
  components: {
    handItem,
  },
  props: ["items","wBen","file_type"],
  data() {
    return {
      imgAll:'',
      ishand: false,
      visible: true,
      setVisible:false,
      setVisible1:false,
      dataAll:{},
      value2:'',
      userfileAuditAdmin: this.$store.state.rolesdata.indexOf("userfileAuditAdmin") >= 0,
      filetype:'',
      fileArr1:[
        {
          value: "1",
          label: "iPhone",
        },
        {
          value: "2",
          label: "iPad",
        },
        {
          value: "3",
          label: "Android",
        },
        {
          value: "4",
          label: "Website",
        },
        {
          value: "5",
          label: "Email",
        },
        {
          value: "6",
          label: "Telephone",
        },
        {
          value: "7",
          label: "Post",
        },
      ],
     
    };
  },
  mounted() {
    console.log(this.items);
   this.echoData()

   
  },

  methods: {
    handleCancel(ev) {
        this.$emit("child", 0);
    },
    btnOkClick(val){
      if (val == 2 && this.value2 == '') {
        App.oTool.warningT("請填寫備註信息");
        return
      }
      if (this.value2 == '') {
        this.value2 = "審批通過"
      }
      if (this.filetype == '')  {
        console.log('11空');
        App.oTool.warningT("請填寫信息");
        return;
      }
      if (this.filetype == 'iPhone') {
        this.filetype = '1'
      }
      if (this.filetype == 'iPad') {
        this.filetype = '2'
      }
      if (this.filetype == 'Android') {
        this.filetype = '3'
      }
      if (this.filetype == 'Website') {
        this.filetype = '4'
      }
      if (this.filetype == 'Email') {
        this.filetype = '5'
      }
      if (this.filetype == 'Telephone') {
        this.filetype = '6'
      }
      if (this.filetype == 'Post') {
        this.filetype = '7'
      }
      console.log("no空",this.dataAll.addresspicurl);
      var addresspicurl = ''
      if (this.dataAll.addresspicurl) {
        if (this.dataAll.addresspicurl.match(/[?&]editid=([^&]+)/)) {
           addresspicurl = this.dataAll.addresspicurl.match(/[?&]editid=([^&]+)/)[1]
        }
      }
      if (this.dataAll.nationcode) {
         this.dataAll.nationcode = this.dataAll.nationcode.replace(/\+/g, '')
      }
      
      this.$ajax({
        method: "post",
        url: this.$api.editQmisUserMsgFilePage,
        data: {
          username: this.dataAll.username,
          cn_name: this.dataAll.cn_name,
          en_name: this.dataAll.en_name,
          nationcode: this.dataAll.nationcode,
          phonenum: this.dataAll.phonenum,
          email: this.dataAll.email,
          id_number: this.dataAll.id_number,
          bank: this.dataAll.bank,
          bank_number: this.dataAll.bank_number,
          address: this.dataAll.address,
          way:this.filetype,
          remark:this.value2,
          editid:this.dataAll.editid,
          // 通讯图片回显
          addresspicurl:addresspicurl,
          // 住在图片回显
          residential_address_pic: this.dataAll.residential_address_pic,
          // 住在地址回显
          new_residential_address: this.dataAll.new_residential_address,
          is_like: this.dataAll.is_like,
          auditstatus:val
        },
      }).then((res) => {
        if (res.data.qmiscode == 1000) {
          // App.oTool.successT();
          this.$emit("child", 0);
        } else {
          App.oTool.warningT(res.data.qmismsg);
        }
      });
      
    },

    echoData(){
      this.$ajax({
        method: "post",
        url: this.$api.getQmisUserMsgWithUsername,
        data: {
          username:this.items.username,
          flag:"audit"
        },
      }).then((res) => {
        if (res.data.qmiscode == 1000) {
          this.dataAll = res.data;
          if (!res.data.nationcode) {
              res.data.phonenum =  '+' + res.data.phonenum.replace(/\+/g, '')
          }
          const firstThreeDigits = res.data.phonenum.substring(0, 4) == '+852';
          const firstThreeDigits1 = res.data.phonenum.substring(0, 4) == '+853';
          const firstThreeDigits2 = res.data.phonenum.substring(0, 4) == '+886';
          const firstThreeDigits3 = res.data.phonenum.substring(0, 2) == '+1';
          if (!res.data.nationcode) {
            if (firstThreeDigits || firstThreeDigits1 || firstThreeDigits2) {
              this.dataAll.nationcode =  res.data.phonenum.slice(0, 4);
              this.dataAll.phonenum =  res.data.phonenum.slice(4);
            }else if(firstThreeDigits3){
              this.dataAll.nationcode =  res.data.phonenum.slice(0, 2);
              this.dataAll.phonenum =  res.data.phonenum.slice(2);
            }else{
              this.dataAll.nationcode =  res.data.phonenum.slice(0, 3);
              this.dataAll.phonenum =  res.data.phonenum.slice(3);

            }
          }
          console.log( this.dataAll);

          this.filetype = this.dataAll.way
          console.log("登入方式获取",this.filetype);
          
        } else {
          App.oTool.warningT(res.data.qmismsg);
        }
      });
    },
    handfn(){
      this.setVisible = false
      this.setVisible1 = false
    },

    

  },
};
</script>

<style lang="scss">
.btnOn{
  margin-right: 15%;
  background: #ed4849;
  border: none;
  border-radius: 4px;
  color: #ffffff;
  padding: 10px 50px;
  cursor: pointer;
}
.btnOK{
  background: #0c8b97;
  border: none;
  border-radius: 4px;
  color: #ffffff;
  padding: 10px 50px;
  cursor: pointer;
}
.myStyle{
  border-bottom: none !important;
}
.show-more{
  text-align: center;
}
.score-img {
  width: 16px;
  transition: all 0.3s;
}
.rotate-img {
  transform: rotate(180deg);
}
.content-top1{
  width: 100%;
  height: 60px;
  background:#ffffff; 
  color: #000000;
  line-height: 60px;
  display: flex;
  padding: 0 20px;

}
.phoneSty .ant-select-arrow {
  right: 6px !important;
}
.phoneSty .ant-input-affix-wrapper .ant-input:not(:first-child) {
  padding-left: 35%;
}
.phoneSty .ant-input-affix-wrapper .ant-input-prefix {
  left: 2px !important;
  top: 18px;

}
.phoneSty .ant-input-affix-wrapper .ant-input-prefix :not(.anticon),
.ant-input-affix-wrapper .ant-input-suffix :not(.anticon) {
  line-height: 25.5px !important;
}
.phoneSty .ant-select-selection {
  border: 0 !important;
  height: 25px;
}
.phoneSty .ant-select-focused .ant-select-selection,
.ant-select-selection:active,
.ant-select-selection:focus {
  border: 0 !important;
  box-shadow: none !important;
}


.address .ant-form-item-label {
  width: 15% !important;
}
.address .ant-form-item-control-wrapper {
  width: 85% !important;
}
.content {
  padding-bottom: 1rem;
  border-radius: 0 0 10px 10px;
  padding: 1rem;
  background-color: #fff;
  width: 38rem;
  margin: 0 auto;
  margin-bottom: 1rem;
  min-height: 50px;
}
#warp_sim12 .ant-modal-header,
#warp_sim12 .ant-modal-body {
  background-color: #e5e5e5 !important;
  padding: 1rem;
  padding-top: 0.7rem;
}

.mark-file {
  position: absolute;
  top: 0;
  left: 0;

  div {
    width: 6rem;
    font-size: 1rem;
    padding: 0.5rem 1rem;
    display: inline-block;
  }
}

#warp_sim12 {
  .ant-radio-wrapper {
    display: flex;
    align-items: center;
  }
  .ant-form-explain {
    display: none;
  }

  .ant-modal {
    top: 8%;
  }

  .ant-col-12 {
    text-align: right;
  }
  .myleft {
    text-align: left;
  }
  .ant-form-item-label {
    width: 30%;
  }

  .ant-form-item,
  .ant-form-item-control {
    width: 100%;

    .ant-calendar-picker {
      width: 100%;
    }
  }

  .ant-radio-group-default {
    width: 100%;
    margin-top: 0.3rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
      font-size: 0.8rem;
    }
  }

  .ant-form-item-control-wrapper {
    width: 70%;

    .ant-form-item-control {
      width: 100%;
    }
  }

  #lastname {
    text-align: right;

    .ant-form-item-label {
      width: 10%;
    }

    .ant-form-item-control-wrapper {
      width: 86%;
    }
  }

  .ant-form-inline .ant-form-item {
    margin-right: 0;
  }

  .ant-modal-content {
    border-radius: 10px;
  }

  .ant-form-item {
    margin-bottom: 1rem;
  }

  .ant-form-item label {
    font-size: 0.8rem !important;
  }

  .ant-input {
    font-size: 0.8rem !important;
  }

  .ant-select-selection-selected-value {
    font-size: 0.8rem !important;
  }

  .ant-form-item-children {
    font-size: 0.8rem !important;
  }

  .ant-modal-body {
    padding: 0;
    padding-top: 2.5rem;
  }

  .btn1 {
    cursor: pointer;
    width: 8rem;
    height: 2rem;
    font-size: 0.8rem;
    color: #fff;
    border: 0;
    border-radius: 5px;
    margin: 0 3rem;
  }

  .btnx {
    background-color: #0c8b97;
  }

  .btn2 {
    background-color: #ed4849;
  }

  .mydivs {
    max-height: 7rem;
    overflow-y: auto;
    // margin-bottom: 1rem;
    padding: 1rem;
    margin-left: 4%;
    width: 96%;
    background-color: #f5f5f5;
    margin-bottom: 1rem;

    .c {
      font-size: 0.8rem;
    }

    .f {
      // text-align: right;
      display: flex;
      justify-content: space-between;
    }

    .t {
      margin: 0.5rem 0;
      border-bottom: 1px solid #d9d9d9;
    }
  }
  .denglu .ant-select{
    width: 9rem;
  }
}
</style>
